/** Close the product selections with the newsletter, then brands and benefits. */
export function homeContentPlacement(blocks: ReadonlyArray<{ type: string }>) {
  const products = blocks.flatMap((block, index) => block.type === 'products' ? [index] : [])
  const firstBenefits = blocks.findIndex(block => block.type === 'benefits')
  const firstBrands = blocks.findIndex(block => block.type === 'brandList')
  const brandsAfter = products.length ? products[products.length - 1] : firstBenefits >= 0 ? firstBenefits - 1 : blocks.length - 1
  return {
    newsletterAfter: firstBrands >= 0 ? firstBrands - 1 : brandsAfter,
    brandsAfter,
    hasAuthoredBrands: firstBrands >= 0,
  }
}
